<div class="card card-custom">
    <div class="card-header">
        <mat-progress-bar mode="indeterminate" *ngIf="viewLoading"></mat-progress-bar>
        <div class="card-title">
            <h3 class="card-label">{{data.title}}</h3>
        </div>
    </div>
    <div class="form">
        <div class="card-body">
            <form [formGroup]="form">
                <div class="form-group row">
                    <div class="col-lg-6 kt-margin-bottom-10-mobile">
                        <mat-form-field class="mat-form-field-fluid">
                            <input matInput placeholder="Amount" formControlName="amount" mask="separator.2" [allowNegativeNumbers]="true" thousandSeparator="," [suffix]="'(' + currency + ')'"/>
                            <mat-error>
                                Amount
                                <strong>required</strong>
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-12">
                        <mat-form-field class="mat-form-field-fluid">
                            <textarea matInput rows="4" [placeholder]="'Comments'" formControlName="comment"></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </div>

        <div class="card-footer b-0 p-0 text-right">
            <div class="form-actions form-actions-solid">
                <div class="row">
                    <div class="col-lg-12">
                        <button mat-button (click)="onNoClick()">
                            Close
                        </button>
                        <button mat-button (click)="save()" color="primary">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>